module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-width"
  }, [(_vm.visible) ? _c('div', {
    staticClass: "pa-3",
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('div', {
    staticClass: "full-width white-background mb-4 pa-2 rounded elevation-2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right",
      "margin-top": "-5px",
      "margin-right": "-5px"
    },
    attrs: {
      "color": "red",
      "icon": "",
      "text": ""
    },
    on: {
      "click": _vm.dismiss
    }
  }, [_c('v-icon', [_vm._v("cancel")])], 1), _vm._v(" "), _c('InterfaceField', {
    attrs: {
      "field": _vm.announcementField,
      "record": _vm.announcementRecord
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.dismiss
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c581106"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/Announcements.vue
// module id = 2636
// module chunks = 1